export class SiteSummary {
  siteId: number;
  siteName: string;
  siteDescription: string;
  siteOwnerName: string;

  /** Backend site-owner entity id. Do not use in frontend flows unless explicitly required. */
  siteOwnerId: number;

  /** Preferred frontend id for site-owner-related operations. */
  siteOwnerSkylarkUserId: number;

  public deserialize(input: any): this {
    this.siteId = input.siteId;
    this.siteName = input.siteName;
    this.siteDescription = input.siteDescription;
    this.siteOwnerName = input.siteOwnerName;
    this.siteOwnerId = input.siteOwnerId;
    this.siteOwnerSkylarkUserId = input.siteOwnerSkylarkUserId;

    return this;
  }
};
